import React from "react";
import {
  Button,
  Menu,
  Icon,
  Dropdown,
  Input,
  Select,
  Opts,
  Tooltip
} from "antd";

import "./styles.scss";

class KeySelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customSearch: "",
      selectedValue: "type",
      general: [
        "VideoCount",
        "AudioCount",
        "FileExtension",
        "Format",
        "Format_Profile",
        "CodecID",
        "FileSize",
        "Duration",
        "OverallBitRate",
        "FrameRate",
        "FrameCount",
        "StreamSize",
        "HeaderSize",
        "DataSize",
        "FooterSize",
        "IsStreamable",
        "Encoded_Application"
      ],
      video: [
        "BitDepth",
        "BitRate",
        "BitRate_Maximum",
        "ChromaSubsampling",
        "CodecID",
        "ColorSpace",
        "DisplayAspectRatio",
        "Duration",
        "Encoded_Date",
        "Encoded_Library",
        "Encoded_Library_Name",
        "Format",
        "Format_Level",
        "Format_Profile",
        "Format_Settings_CABAC",
        "Format_Settings_RefFrames",
        "FrameCount",
        "FrameRate",
        "FrameRate_Mode",
        "Height",
        "ID",
        "PixelAspectRatio",
        "Rotation",
        "Sampled_Height",
        "Sampled_Width",
        "ScanType",
        "StreamOrder",
        "StreamSize",
        "Tagged_Date",
        "Width"
      ],
      audio: [
        "BitRate",
        "BitRate_Maximum",
        "BitRate_Mode",
        "ChannelLayout",
        "ChannelPositions",
        "Channels",
        "CodecID",
        "Compression_Mode",
        "Duration",
        "Encoded_Date",
        "Format",
        "Format_Profile",
        "Format_Settings_SBR",
        "FrameCount",
        "FrameRate",
        "ID",
        "SamplesPerFrame",
        "SamplingCount",
        "SamplingRate",
        "StreamOrder",
        "StreamSize",
        "StreamSize_Proportion",
        "Tagged_Date"
      ],
      others: ["mime_type", "last_modified", "size", "type"]
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {}

  handleSearch(v) {
    this.props.onKeyChange(v);
    this.setState({ customSearch: v, selectedValue: null });
  }

  handleChange(v) {
    this.props.onKeyChange(v);
    this.setState({ selectedValue: v });
  }

  render() {
    const {
      general,
      audio,
      video,
      others,
      customSearch,
      selectedValue
    } = this.state;
    return (
      <Select
        size="large"
        name="metadata_key"
        className={"search-meta-key"}
        onChange={this.handleChange}
        notFoundContent={"Enter Metadata Key"}
        style={{ width: "100%" }}
        showArrow={false}
        onSearch={this.handleSearch}
        value={this.props.value}
        //onFocus={on_metadata_key_focus}
        showSearch
      >
        <Select.OptGroup label="General">
          {general.map(e => (
            <Select.Option key={`metadata.${e}`}>{e}</Select.Option>
          ))}
          {others.map(e => (
            <Select.Option key={e}>{e}</Select.Option>
          ))}
        </Select.OptGroup>
        <Select.OptGroup label="Video">
          {video.map(e => (
            <Select.Option key={`metadata.Video.${e}`}>{e}</Select.Option>
          ))}
        </Select.OptGroup>
        <Select.OptGroup label="Audio">
          {audio.map(e => (
            <Select.Option key={`metadata.Audio.${e}`}>{e}</Select.Option>
          ))}
        </Select.OptGroup>
      </Select>
    );
  }
}

class ComparatorSelection extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    const { onComparatorChange } = this.props;
    const comparators = [
      { name: "Exact Match", value: "match" },
      { name: "Contains", value: "contains" },
      { name: "Does not contain", value: "does not contain" },
      { name: "Does not match", value: "does not match" }
    ];
    return (
      <Select
        className="comparator-btn"
        onSelect={onComparatorChange}
        dropdownMatchSelectWidth={false}
        placeholder={"Select a comparator"}
        size="large"
        style={{ width: 150 }}
        value={this.props.value}
      >
        {comparators.map(s => (
          <Select.Option key={s.value} value={s.value}>
            {s.name}
          </Select.Option>
        ))}
      </Select>
    );
  }
}

const ValueInput = ({ onValueChange, value }) => {
  return (
    <Input
      placeholder="Metadata Value"
      size="small"
      className={"search-meta-val"}
      onChange={onValueChange}
      value={value}
      autoFocus
    />
  );
};

class Filter extends React.Component {
  constructor(props) {
    super(props);
    const { id, metadataKey, comparator, metadataValue } = this.props;
    this.state = {
      id: id,
      metadataKey: metadataKey,
      comparator: comparator,
      metadataValue: metadataValue
    };

    this.onFilterChange = this.onFilterChange.bind(this);
  }

  onFilterChange(type, value) {
    const { onChange } = this.props;
    if (type === "key") {
      this.setState({ metadataKey: value });
      onChange(Object.assign(this.state, { metadataKey: value }));
    } else if (type === "comparator") {
      this.setState({ comparator: value });
      onChange(Object.assign(this.state, { comparator: value }));
    } else if (type === "value") {
      const val = Filter.parseIfNumber(value);
      this.setState({ metadataValue: val });
      onChange(Object.assign(this.state, { metadataValue: val }));
    }
  }

  static parseIfNumber(value) {
    const re = /^\d+$/;
    if (re.test(value.trim())) return parseInt(value);
    return value;
  }

  render() {
    const { metadataKey, comparator, metadataValue } = this.state;
    return (
      <div className="advanced-search-div" key={this.props.id}>
        <KeySelection
          onKeyChange={e => this.onFilterChange("key", e)}
          value={metadataKey}
        />
        <ComparatorSelection
          onComparatorChange={e => this.onFilterChange("comparator", e)}
          value={comparator}
        />
        <ValueInput
          onValueChange={e => this.onFilterChange("value", e.target.value)}
          value={metadataValue}
        />
        <Button
          className="delete-btn"
          onClick={() => this.props.onDelete(this.props.id)}
          shape={"circle"}
          icon={"delete"}
        />
      </div>
    );
  }
}

export default class QueryView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      counter: 1,
      filters: [
        {
          id: 0,
          metadataKey: "type",
          comparator: "contains",
          metadataValue: ""
        }
      ] // items format : {id: 0, metadataKey: "", comparator: "", metadataValue: ""}
    };

    this.onAddFilter = this.onAddFilter.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.makeRequestBody = this.makeRequestBody.bind(this);
    this.onDelete = this.onDelete.bind(this);
  }

  onAddFilter() {
    const { filters } = this.state;
    const newFilters = filters.concat([
      {
        id: this.state.counter,
        metadataKey: "type",
        comparator: "contains",
        metadataValue: ""
      }
    ]);
    this.setState({ filters: newFilters, counter: this.state.counter + 1 });
  }

  onFilterChange(filterObj) {
    const otherFilters = this.state.filters.filter(
      obj => obj.id !== filterObj.id
    );
    otherFilters.push(filterObj);
    this.setState({ filters: otherFilters });

    if (this.isFilterValid(filterObj)) {
      this.props.onFilterBodyMade(this.makeRequestBody(otherFilters));
    }
  }

  onDelete(id) {
    const target = this.state.filters.filter(obj => obj.id === id)[0];
    const filters = this.state.filters.filter(obj => obj.id !== id);
    this.setState({ filters });

    if (this.isFilterValid(target)) {
      // so the search is triggered only if the filter was already working
      // and not when it was empty or not valid yet and the user decided to delete it
      this.props.onFilterBodyMade(this.makeRequestBody(filters));
    }
  }

  isFilterValid(obj) {
    return (
      obj.metadataKey !== "" &&
      obj.comparator !== "" &&
      obj.metadataValue !== ""
    );
  }

  makeRequestBody(filters) {
    return filters.filter(this.isFilterValid).map(filterObj => {
      return {
        type: "statement",
        field: filterObj.metadataKey,
        value: filterObj.metadataValue,
        comparator: filterObj.comparator.toLowerCase()
      };
    });
  }

  render() {
    const { loading, show_query, onFilterBodyMade, on_show_query } = this.props;
    const { filters } = this.state;
    return (
      <div className="query-view">
        {show_query ? (
          <div className="advanced-search">
            <span className="x-title"> Advanced Search </span>
            <div className="filters">
              {filters.length !== 0 ? (
                filters.map(
                  ({ id, metadataKey, comparator, metadataValue }) => (
                    <Filter
                      key={id}
                      id={id}
                      metadataKey={metadataKey}
                      comparator={comparator}
                      metadataValue={metadataValue}
                      onChange={this.onFilterChange}
                      onDelete={this.onDelete}
                    />
                  )
                )
              ) : (
                <div className={"no-filters"}>No Filters Applied</div>
              )}
            </div>

            <div className="add-btn-container">
              <Button
                onClick={this.onAddFilter}
                className="advanced-search-add"
              >
                Add Filter
              </Button>
            </div>

            <br />

            <div>
              <a
                href="#"
                onClick={on_show_query}
                className="advanced-search-link"
              >
                Hide
              </a>
            </div>
            {/*<Button type="primary" onClick={()=>{}}>Search</Button> */}
          </div>
        ) : (
          <div className="advanced-search-link">
            <a
              href="#"
              onClick={on_show_query}
              className="advanced-search-link"
            >
              View Advanced Search Options
            </a>
          </div>
        )}
      </div>
    );
  }
}
